<template>
  <a class="pointer delete" @click="click" v-c-tooltip.hover.click="'Delete'">
    <CIcon name="cil-trash" /> {{ label }}
  </a>
</template>
<script>
export default {
  props: ["label"],
  methods: {
    click() {
      const conf = confirm("Yakin akan menghapus item ?");
      if (conf) {
        this.$emit("click");
        this.$toasted.success("data berhasil dihapus").goAway();
      }
    },
  },
};
</script>